"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genereateViewerId = void 0;
const genereateViewerId = () => {
    const baseViewerId = 1000000000;
    // Get last 9 digits of timestamp to ensure uniqueness
    const timestampComponent = Date.now() % baseViewerId;
    // Add a small random number (0-999) to prevent collisions
    const randomComponent = Math.floor(Math.random() * 1000);
    const viewerId = (baseViewerId + timestampComponent + randomComponent);
    return viewerId;
};
exports.genereateViewerId = genereateViewerId;
